import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { addPartnerDatabase } from "../api/contactsApi";

const useAddPartner = () => {
  const auth = useAuth();
  const { token, uid_user, uid_partner } = auth.getSessionData();
  return useMutation({
    mutationFn: async (data) => {
      const res = await addPartnerDatabase({
        data: {
          ...data,
          uid_user,
          partner: !uid_partner ? data.uid_partner : null,
        },

        token,
      });
      return res
    },
  });
};

export default useAddPartner;
